import { Record } from 'immutable';
import { Base } from './base';

class Hour extends Base(Record({
    id: null,
    close: null,
    day: '',
    open: null,
    place_id: null
  })) {
    $create(id) {
      if (this.id && this.state.entities.get('hours').get(this.id).isSuperset(this)) {
        return Promise.resolve('No op');
      }

      return Promise.all([
        this.id && this.$delete(),
        this.api.post({
          resource: 'hours'
        }, this.api.payload('hours', id ? this.set('place_id', id) : this))
      ]);
    }

    $delete() {
      return this.api.delete({
        id: this.id,
        resource: 'hours'
      });
    }

    $get(id) {
      if (this.place_id) id = this.place_id;

      if (!id) return Promise.resolve(null);

      this.dispatch(this.actions.clearEntities('hours'));

      return this.api.get({
        resource: 'hours?filter[place_id]=' + id
      })
      .then(res => this.dispatch(this.actions.receiveEntities(res.data, 'hours')));
    }
  }

export default Hour;



// WEBPACK FOOTER //
// ./src/records/hour.js